import { render, staticRenderFns } from "./MissionRankingSharePostSection.vue?vue&type=template&id=586fa3e7&scoped=true"
import script from "./MissionRankingSharePostSection.vue?vue&type=script&lang=ts"
export * from "./MissionRankingSharePostSection.vue?vue&type=script&lang=ts"
import style0 from "./MissionRankingSharePostSection.vue?vue&type=style&index=0&id=586fa3e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586fa3e7",
  null
  
)

export default component.exports